import {Component, OnInit} from '@angular/core';
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

@Component({
  selector: 'app-pharmacy-card-skeleton',
  templateUrl: './pharmacy-card-skeleton.component.html',
  styleUrls: ['./pharmacy-card-skeleton.component.scss'],
  imports: [
    NgxSkeletonLoaderModule
  ],
  standalone: true
})
export class PharmacyCardSkeletonComponent implements OnInit {
// "SANTORO SAS" - titolo bold uppercase
  skeletonNameTheme = {
    width: '140px',
    height: '18px',
    margin: '0'
  };

// badge "Aperta ora"
  skeletonBadgeTheme = {
    width: '90px',
    height: '24px',
    'border-radius': '999px',
    margin: '0'
  };

// "Via Garibaldi, 192 - Andria, BT"
  skeletonAddressTheme = {
    width: '200px',
    height: '15px',
    margin: '0'
  };

// "+39 0883 599164"
  skeletonPhoneTheme = {
    width: '150px',
    height: '15px',
    margin: '0'
  };

// "745 m · 9 min"
  skeletonDistanceTheme = {
    width: '110px',
    height: '14px',
    margin: '0'
  };

// icona a piedi
  skeletonIconTheme = {
    width: '14px',
    height: '16px',
    'border-radius': '3px',
    margin: '0'
  };

  constructor() {
  }

  ngOnInit() {
  }

}
